import { crm } from "../../../theme";
import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Flex,
  Heading,
  Text,
  useToast,
} from "@chakra-ui/react";
import { getCompanies } from "../../../services/companyService";
import { setRefAsync } from "../../../services/userService";
import SearchableSelect from "../../../components/SearchableSelect";
import ProcessInput from "../../purchase-order/save/components/ProcessInput";
import { useCompany } from "../../../contexts/CompanyContext";

const ClientRef = () => {
  const toast = useToast();
  const [loading, setLoading] = useState(true);
  const [companies, setCompanies] = useState<any[]>([]);
  const [company, setCompany] = useState<any>([]);
  const [processId, setProcessId] = useState<string>();
  const { currentCompany } = useCompany();
  const getCompaniesOptions = async () => {
    const response = await getCompanies(false, currentCompany);
    if (response) {
      setCompanies(response);
      setLoading(false);
    }
  };
  useEffect(() => {
    getCompaniesOptions();
  }, [currentCompany]);

  const setRef = async () => {
    setLoading(true);
    try {
      const response = await setRefAsync(processId ?? "", company);

      if (response) {
        toast({
          title: "O processo agora aparece para o cliente.",
          status: "success",
          duration: 4000,
          isClosable: true,
        });
      }
    } finally {
      setLoading(false);
    }
  };
  const canSaveRef = !!processId && typeof company === "string" && company !== "";
  return (
    <Box width="100%">
      <Heading size="lg" fontWeight="normal" mb="24px">
        <Flex alignItems="center" gap="12px">
          <span
            className="material-symbols-outlined"
            style={{ fontSize: "32px", color: "var(--icon-color)" }}
          >
            group
          </span>{" "}
          Adicionar ref de cliente
        </Flex>
      </Heading>
      <Text mt="8px">
        Serve para o processo permanecer vinculado a CVF, mas aparecer para o
        cliente
      </Text>
      <Box backgroundColor="white" borderRadius="12px" border={`1px solid ${crm.border}`} boxShadow={crm.shadowSm} p="24px" mt="16px">
        <Heading size="sm" fontWeight="normal" mb="8px">
          Empresa
        </Heading>
        <SearchableSelect
          options={companies.map((c) => ({ value: c.id, label: c.name }))}
          value={company}
          setValue={(value) => setCompany(value)}
        />
      </Box>
      <ProcessInput {...{ processId, setProcessId }} />
      <Flex justifyContent="flex-end" mb="32px">
        <Button
          marginTop="32px"
          onClick={() => setRef()}
          isLoading={loading}
          isDisabled={!canSaveRef}
          backgroundColor={crm.brand}
          color="white"
          borderRadius="10px"
          _hover={{ backgroundColor: crm.brandDark }}
        >
          Salvar Ref
        </Button>
      </Flex>
    </Box>
  );
};

export default ClientRef;
